import React from "react";
import { Navigate } from "react-router-dom";

const DeleteAccountPage: React.FC = () => (
  <Navigate to="/safety#delete-account" replace />
);

export default DeleteAccountPage;
